import React from 'react';
import columns from './columns';
import FamilyWebFilters from './family-web-filters';
import Breadcrumbs from 'components/Common/Breadcrumb';
import messages from './messages';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';

const FamiliesWebPage = () => {
  const {t} = useTranslation();
  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.pageTitle())}</title>
      </Helmet>
      <Container fluid>
        <Breadcrumbs
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {title: t('common.products'), path: '/dashboard/products'},
            {title: t(...messages.families()), path: '#'},
          ]}
        />
        <Table
          columns={columns}
          hideSearch
          url="product-family-webs"
          name="families-web"
          filtersComponent={FamilyWebFilters}
        />
      </Container>
    </div>
  );
};

export default FamiliesWebPage;
